import {
  useMotionValueEvent,
  useScroll,
  useTransform,
  motion,
} from "framer-motion";
import { useCallback, useContext, useEffect, useMemo, useRef } from "react";
import styled from "styled-components";
import ContactForm from "./ContactForm.js";
import InputCard from "../../../helperComponents/InputCard.js";
import Context from "../../../../Context.js";
import { useTranslation } from "react-i18next";

let canvasDimension = 1000;

const Canvas = styled.canvas`
  margin-left: 0;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70vw;

  @media (max-width: 900px) {
    width: 90vw;
  }

  /* background-image: url("/dumbbells.jpg"); */
`;

let maxFrames = 40;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  gap: 100px;
  justify-content: center;

  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-start;
    gap: 30px;
  }
`;

const Img = styled.img`
  height: 30vw;

  @media (max-width: 900px) {
    display: none;
  }
`;

const AnimatedHeroImage = styled.img`
  width: 30vw;
  height: 30vw;
  border-radius: 15px;
  object-fit: cover;
  box-shadow:
    5px 5px #44be30,
    12px 12px #196a07;
  margin-top: 10px;
  animation: centerScaleReveal 0.4s ease-in;

  @media (max-width: 900px) {
    width: 90vw;
    height: 90vw;
    border-radius: 10px;
    box-shadow:
      5px 5px #44be30,
      12px 12px #196a07;
  }
`;

export default function ContactUs({ containerRef }) {
  const { isMobile } = useContext(Context);

  const targetRef = useRef(null);
  const { t } = useTranslation();

  const textAnimation = useScroll({
    container: containerRef,
    target: targetRef,
    offset: ["0.1 1", "0.4 1"],
  });

  return (
    <Container
      id="contact-us"
      ref={targetRef}
      style={{
        display: "flex",
      }}
    >
      <motion.div
        style={{
          scale: textAnimation.scrollYProgress,
          width: "100%",
        }}
      >
        <Row>
          <AnimatedHeroImage src="/hero/heroimage2.jpg" />

          <InputCard
            style={{
              width: isMobile ? "100%" : "600px",
              padding: "20px 5px",
              height: "580px",
            }}
            title={t("contactUsTitle")}
          >
            <ContactForm />
          </InputCard>
        </Row>
      </motion.div>
    </Container>
  );
}
